export default __webpack_public_path__ + "static/media/product_3.98621e43.png";